import { useOutletContext, Outlet as RouterOutlet } from "react-router-dom";
export function Outlet() {
  const context = useOutletContext();
  return <RouterOutlet context={context} />;
}
